<template>
  <b-modal
    :id="modalId"
    ref="modal"
    title="選擇上課日期"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    size="sm"
  >
    <div class="class-time-label">上課分校</div>
    <v-select
      v-model="selectedEnrollment.center_id"
      :clearable="false"
      label="label"
      :options="centerOptions"
      :reduce="center => center.id"
      class="class-time-select"
    />

    <div class="class-time-label mt-1">上課日期</div>
    <flat-pickr
      v-model="selectedEnrollment.class_date"
      class="form-control"
      :config="dateConfig"
    />

    <div class="class-time-panel mt-1">
      <div class="class-time-label">上課時間</div>
      <b-row class="align-items-center justify-content-center no-gutters class-time-row">
        <b-col cols="5">
          <v-select
            v-model="selectedEnrollment.class_hour"
            :clearable="false"
            label="label"
            :options="hourOptions"
            :reduce="hour => hour.value"
            class="class-time-select"
          />
        </b-col>
        <b-col cols="2" class="text-center class-time-separator">:</b-col>
        <b-col cols="5">
          <v-select
            v-model="selectedEnrollment.class_minute"
            :clearable="false"
            label="label"
            :options="minuteOptions"
            :reduce="minute => minute.value"
            class="class-time-select"
          />
        </b-col>
      </b-row>
    </div>
    <div class="class-time-label mt-1">老師</div>
    <v-select
      v-model="selectedEnrollment.user_id"
      :clearable="false"
      label="label"
      :options="teacherOptions"
      :reduce="teacher => teacher.value"
      class="class-time-select"
    />
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="outline-secondary" @click="cancel()">
        取消
      </b-button>
      <b-button size="sm" variant="primary" @click="submit('single')">
        確定
      </b-button>
      <b-button size="sm" variant="warning" class="ml-2" @click="submit('all')">
        確定 (往後轉)
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import moment from 'moment'
import {
  BModal, BRow, BCol, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    flatPickr,
    vSelect,
    BModal,
    BRow,
    BCol,
    BButton,
    ToastificationContent,
  },
  props: {
    modalId: {
      type: String,
      default: 'change-date-modal',
    },
    teacherOptions: {
      type: Array,
      default: () => [],
    },
    userId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      dateConfig: {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'j F, Y',
      },
      centerOptions: [],
      selectedEnrollment: {
        enrollment_id: null,
        class_date: moment().format('YYYY-MM-DD'),
        class_hour: null,
        class_minute: null,
        center_id: null,
        grade_id: null,
        user_id: null,
      },
      hourOptions: Array.from({ length: 15 }, (value, index) => ({
        label: String(index + 7).padStart(2, '0'),
        value: String(index + 7).padStart(2, '0'),
      })),
      minuteOptions: [
        { label: '00', value: '00' },
        { label: '15', value: '15' },
        { label: '30', value: '30' },
        { label: '45', value: '45' },
      ],
    }
  },
  created() {
    this.getCenterData()
  },

  methods: {
    getCenterData() {
      this.$http.get(`${process.env.VUE_APP_API_BASE}/centers/?all_center=true`)
        .then(res => {
          this.centerOptions = res.data.centers || []
        })
    },
    open(enrollment) {
      const start = (enrollment.start || '00:00').split(':')
      this.selectedEnrollment = {
        enrollment_id: enrollment.enrollment_id || enrollment.id,
        class_date: moment().format('YYYY-MM-DD'),
        class_hour: start[0],
        class_minute: start[1],
        center_id: enrollment.center_id || null,
        grade_id: enrollment.grade_id,
        user_id: this.userId,
      }
      this.$refs.modal.show()
    },
    submit(action) {
      const payload = {
        datetime: `${this.selectedEnrollment.class_date} ${this.selectedEnrollment.class_hour}:${this.selectedEnrollment.class_minute}`,
        grade_id: this.selectedEnrollment.grade_id,
        center_id: this.selectedEnrollment.center_id,
        user_id: this.selectedEnrollment.user_id,
        action,
      }

      this.$http.post(
        `${process.env.VUE_APP_API_BASE}/enrollment/${this.selectedEnrollment.enrollment_id}/change_datetime/`,
        payload,
      ).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: { title: '轉堂成功', icon: 'CheckIcon', variant: 'success' },
        })
        this.$emit('changed')
      })
    },
  },
}
</script>
